import {
  Button,
  Group,
  LoadingOverlay,
  Modal,
  Stack,
  Text
} from '@mantine/core'
import { IconTrash } from '@tabler/icons-react'
import { FormattedMessage, useIntl } from 'react-intl'
import { extractErrorMessage } from '@/api/helpers/extractErrorMessage'
import { useDeleteModel } from '@/queries/modelQueries'
import { showToast } from '@/theme/notifications'

type DeleteModelModalProps = {
  opened: boolean
  modelId?: string
  modelName?: string
  onClose: () => void
  onDeleted: () => void
}

const DeleteModelModalTitle = () => (
  <Group>
    <IconTrash size={20} />
    <FormattedMessage id="models.delete" />
  </Group>
)

export const DeleteModelModal = ({
  opened,
  modelId,
  modelName,
  onClose,
  onDeleted
}: DeleteModelModalProps) => {
  const intl = useIntl()
  const { mutateAsync: deleteModel, isPending } = useDeleteModel()

  const handleConfirmDelete = async () => {
    if (!modelId) {
      return
    }

    try {
      await deleteModel(modelId)
      showToast(intl.formatMessage({ id: 'models.delete.success' }), 'success')
      onDeleted()
    } catch (err) {
      showToast(
        extractErrorMessage(
          err,
          intl.formatMessage({ id: 'models.delete.error' })
        ),
        'error'
      )
    }
  }
  return (
    <Modal
      size="lg"
      opened={opened}
      title={<DeleteModelModalTitle />}
      onClose={onClose}
    >
      <LoadingOverlay visible={isPending} />

      <Stack gap="xl">
        <div>
          <Text size="sm" mb="md">
            <FormattedMessage
              id="models.delete.confirmation"
              values={{ name: modelName || '' }}
            />
          </Text>

          <Text size="sm">
            <FormattedMessage id="models.delete.note" />
          </Text>
        </div>

        <Group justify="end">
          <Button miw={120} variant="default" onClick={onClose}>
            <FormattedMessage id="cancel" />
          </Button>

          <Button color="red" onClick={() => void handleConfirmDelete()}>
            <FormattedMessage id="models.delete" />
          </Button>
        </Group>
      </Stack>
    </Modal>
  )
}
